import devConfig from './config.Dev';
import prodConfig from './config.Production';
import preprodConfig from './config.PreProd';
import qaConfig from './config.QA';

const GOOGLE_TRACKING_ID = 'UA-88662464-1';
const DD_CLIENT_KEY = 'pub9ae9b42cdd45c7c9b928c0082d23059d';
const ENV = 'prod';

function GetEnv(envStr) {
  switch (envStr.toLowerCase()) {
    case 'production':
    case 'prod':
      return prodConfig;
    case 'preprod':
      return preprodConfig;
    case 'qa':
      return qaConfig;
    default:
      return process.env.NODE_ENV.toLowerCase() === 'qa'
        ? qaConfig
        : process.env.NODE_ENV.toLowerCase() === 'preprod'
          ? preprodConfig
          : devConfig;
  }
}

const Config = GetEnv(ENV);

export default {...Config, GOOGLE_TRACKING_ID, DD_CLIENT_KEY};



// WEBPACK FOOTER //
// ./src/config/index.js